module.exports = __webpack_public_path__ + "static/img/042统战H5页面.ef8c5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/042统战H5页面.jpg
// module id = I5F6
// module chunks = 0